import { format, isSameDay } from "date-fns";
import type { Task } from "../types";

export function multiDayTask(task: Task) {
  if (!task.scheduled_start || !task.scheduled_end) return false;
  return !isSameDay(
    new Date(task.scheduled_start),
    new Date(new Date(task.scheduled_end).getTime() - 1),
  );
}
export function taskPeriodLabel(task: Task, includeDate = false) {
  if (!task.scheduled_start || !task.scheduled_end) return "";
  const start = new Date(task.scheduled_start),
    end = new Date(task.scheduled_end);
  return `${format(start, multiDayTask(task) || includeDate ? "dd.MM.yyyy HH:mm" : "HH:mm")} — ${format(end, multiDayTask(task) || includeDate ? "dd.MM.yyyy HH:mm" : "HH:mm")}`;
}
export function taskDayLabel(task: Task, day: Date) {
  if (!multiDayTask(task)) return "";
  if (isSameDay(day, new Date(new Date(task.scheduled_end!).getTime() - 1)))
    return "Завершить сегодня";
  return isSameDay(day, new Date(task.scheduled_start!))
    ? "Начало"
    : "Продолжается";
}
